// src/stores/authStore.js
import { defineStore } from "pinia";
import { authService } from "@/services/authService";
import { toast } from 'vue3-toastify';
import Cookies from "js-cookie";

// Funções auxiliares para manipulação do localStorage
const setLocalStorage = (token, user) => {
  localStorage.setItem("token", token.split("|")[1]);
  localStorage.setItem("user", JSON.stringify(user));
  localStorage.setItem("expiresAt", new Date().getTime() + 3600 * 1000);
};

const clearLocalStorage = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("expiresAt");
};

export const useAuthStore = defineStore("authStore", {
  state: () => ({
    user: JSON.parse(localStorage.getItem("user")) || null,
    token: localStorage.getItem("token") || null,
    isAuthenticated: !!localStorage.getItem("token"),
  }),

  actions: {
    async register(payload) {
      try {
        const response = await authService.signUp(payload);

        this.token = response.data.data.token;
        this.user = response.data.data.user;
        this.isAuthenticated = true;

        setLocalStorage(this.token, this.user);
        Cookies.remove("referral");

        toast.success(response.data.data.message);
        return response;
      } catch (error) {
        toast.error(error.response?.data?.message);
        throw error;
      }
    },

    async login(payload) {
      try {
        const response = await authService.signIn(payload);

        this.token = response.data.data.token;
        this.user = response.data.data.user;
        this.isAuthenticated = true;

        setLocalStorage(this.token, this.user);

        toast.success(response.data.data.message);

        return response;
      } catch (error) {
        toast.error(error.response?.data?.message);
        throw error;
      }
    },

    async logout() {
      try {
        if (this.token) {
          await authService.logout(this.token);
        }
      } catch (error) {
        toast.error(error.response?.data?.message);
      } finally {
        this.token = null;
        this.user = null;
        this.isAuthenticated = false;
        clearLocalStorage();
      }
    },

    async forgotPassword(payload) {
      try {
        const response = await authService.forgotPassword(payload);
        toast.success(response.data.message);
        return response;
      } catch (error) {
        toast.error(error.response?.data?.message);
        throw error;
      }
    },

    async resetPassword(payload) {
      try {
        const response = await authService.resetPassword(payload);
        toast.success(response.data.message);
        return response;
      } catch (error) {
        toast.error(error.response?.data?.message);
        throw error;
      }
    },

    autoLogin() {
      const token = localStorage.getItem("token");
      const user = JSON.parse(localStorage.getItem("user"));
      const expiresAt = localStorage.getItem("expiresAt");

      if (token && user && expiresAt) {
        const now = new Date().getTime();
        if (now < expiresAt) {
          this.token = token;
          this.user = user;
          this.isAuthenticated = true;
        } else {
          this.logout();
        }
      }
    },
  },
});
